// Actions
export const Types = {
  SUCCESS: 'auth/SUCCESS',
  FAILURE: 'auth/FAILURE',
  REFRESH_SUCCESS: 'auth/REFRESH_SUCCESS',
  RESET: 'auth/RESET'
}

// Initial state
const initial = {
  status: '',
  auth: {}
}

// Reducer
export default function reducer(state = initial, action = {}) {
  switch (action.type) {
    case Types.SUCCESS: {
      console.tron.log('success', action)
      return { ...state, status: 'success', auth: action.payload }
    }

    case Types.REFRESH_SUCCESS: {
      const { token, accessTokenExp } = action.payload

      return {
        ...state,
        status: 'success',
        auth: {
          ...state.auth,
          token,
          accessTokenExp
        }
      }
    }

    case Types.FAILURE: {
      return { ...state, status: 'failure' }
    }

    case Types.RESET: {
      return { ...initial }
    }

    default:
      return state
  }
}

export const Creators = {
  success: (payload) => ({
    type: Types.SUCCESS,
    payload
  }),
  reset: () => ({
    type: Types.RESET
  }),
  refreshSuccess: (payload) => ({
    type: Types.REFRESH_SUCCESS,
    payload
  })
}
